import apiService from '../../services/api';
import CONSTANTS from '@/constants';
import API_CONFIG from '@/api-config';
import axios from 'axios';

// Init state
const state = {
    item: null,
    items: [],
    layerOption: CONSTANTS.GEOJSON_TYPE.REAL_RAIN,
    analyzeData: {}
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('geojson.index', params).then(response => {
            context.commit('GET_LIST_SUCCESS', response);
            return response;
        });
    },
    downGeoJson: (context, params) => {
        return apiService.get('geojson.detail', params).then(response => {
            context.commit('SET_GEOJSON', response);
            return response;
        });
    },
    getFloodDataAnalyze: (context, params) => {
        return apiService.get('geojson.detail', params).then(response => {
            context.commit('setAnalyzeData', response);
        });
    },
    getAnalyzeXlsx: (context, params) => {
        return apiService.get('geojson.detail', params).then(response => {
            return response;
        });
    },
    async deleteGeoJson(context, params) {
        await apiService.delete('geojson.detail', params);
    },
    async uploadFile(context, data) {
        await axios.post(API_CONFIG.BASE_URL + API_CONFIG.geojson.index, data);
    }
};

// Mutation
const mutations = {
    SET_GEOJSON: (state, response) => {
        state.item = response;
    },
    GET_LIST_SUCCESS: (state, response) => {
        state.items = response;
    },
    SET_LAYER_OPTION(state, data) {
        state.layerOption = data;
    },
    setAnalyzeData(state, data) {
        state.analyzeData = data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
